export const GET_UPCOMING_LIVE_CLASSES_REQUEST =
  "GET_UPCOMING_LIVE_CLASSES_REQUEST";
export const GET_UPCOMING_LIVE_CLASSES_SUCCESS =
  "GET_UPCOMING_LIVE_CLASSES_SUCCESS";
export const GET_UPCOMING_LIVE_CLASSES_FAILURE =
  "GET_UPCOMING_LIVE_CLASSES_FAILURE";
